// extracted by mini-css-extract-plugin
export default {"PageCarteBancaire":"PageCarteBancaire_PageCarteBancaire__b5Jew","Loader":"PageCarteBancaire_Loader__Db06x","PartieGauche":"PageCarteBancaire_PartieGauche__aR8ON"};